function icon_check() {
    return (
        <svg className="icon icon_check" width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M6.69613 0.269451C6.87 0.397729 6.90253 0.63691 6.76877 0.803672L2.79714 5.75607C2.72747 5.84293 2.62215 5.89683 2.50808 5.90392C2.39403 5.91104 2.28232 5.87066 2.20151 5.79317L0.21569 3.88841C0.0605902 3.73961 0.0605902 3.49843 0.21569 3.34963C0.370794 3.20087 0.622262 3.20087 0.777366 3.34963L2.44333 4.94761L6.13918 0.339131C6.27291 0.172365 6.52229 0.141169 6.69613 0.269451Z" />
        </svg>
    )
}

export default icon_check